import { TFunction } from 'i18next'

export default (t: TFunction) => ({
  dataSetName: t('materialCosts'),
  dataName: t('material'),
  aggregate: ['price'],
  head: [
    {
      label: t('product'),
      key: 'product',
      col: 2,
      leftAlign: true,
      placeholder: t('newMaterial'),
      hasOptions: true,
    },
    {
      label: t('producer'),
      key: 'producer',
      col: 2,
      placeholder: t('producer'),
    },
    {
      label: t('amount'),
      key: 'amount',
      placeholder: '0,000',
      col: 2,
      editable: true,
    },
    {
      label: t('quantityAndWaste'),
      key: 'amountWithClipping',
      placeholder: '0,000',
      col: 2,
      editable: true,
    },
    {
      label: t('price/Unit'),
      key: 'unitPrice',
      col: 2,
      placeholder: '0,00',
      unit: 'EUR',
      editable: true,
    },
    {
      label: t('price'),
      key: 'totalPrice',
      col: 2,
      placeholder: '0,00',
      unit: 'EUR',
    },
  ],
})
